import React from 'react';

const reviews = [
  {
    id: 1,
    business: 'The Hair Queen',
    author: 'T. Sanders',
    review: 'I started using yiBooking and fell in love with it! My customers book their own appointments.',
    logo: 'https://images.unsplash.com/photo-1760138270903-d95903188730?w=200'
  },
  {
    id: 2,
    business: 'Phoenix Balboa', 
    author: 'Phoenix',
    review: 'Great product. Easy to set up and the automatic notifications are great.',
    logo: 'https://images.unsplash.com/photo-1760037028517-e5cc6e3ebd3e?w=200'
  },
  {
    id: 3,
    business: 'J+K Fitness',
    author: 'Jae K.',
    review: 'yiBooking is awesome. Studio was running in minutes.',
    logo: 'https://images.unsplash.com/photo-1660154349284-12991dedc60d?w=200'
  }
];

const Reviews = () => (
  <section className="py-20 bg-gray-400">
    <div className="max-w-7xl mx-auto px-6">
      <h2 className="text-4xl font-light text-white text-center mb-16">
        Reviews for yiBooking Appointment Scheduling Software
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {reviews.map((r) => (
          <div key={r.id} className="bg-white rounded-lg p-8 shadow-lg">
            <div className="flex flex-col items-center mb-6">
              <div className="w-24 h-24 rounded-full mb-4 overflow-hidden">
                <img src={r.logo} alt={r.business} className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800">{r.business}</h3>
              <p className="text-gray-500 text-sm">{r.author}</p>
            </div>
            <div className="border-t pt-6">
              <p className="text-gray-600 text-center italic">{r.review}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Reviews;
